import React from 'react';
import { useTranslation, Trans } from "react-i18next";

import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import Cookies from 'js-cookie';

import Hero from "../../components/hero/Hero";
import Features from "../../components/features/Features";
import StepsContainer from "../../components/steps/StepsContainer";
import SliderTestimonials from "../../components/slider-testimonials/SliderTestimonials";
import WhatIsMilluu from "../../components/what-is-milluu/WhatIsMilluu";
import MainButton from "../../components/main-button/MainButton";
// import { Helmet } from 'react-helmet';

import bgHero from '../home/img/bg-hero-proprietari-new.png';
// import bgHeroMobile from '../home/img/bg-hero-proprietari-newmobile.png';
import gradientHero from './img/bg-gradient-chiriasi-new.png';
// import illustrationProprietar from "../../resources/img/illustration-proprietar.svg";
import illustrationQuestion from "../owners/img/Illustration_question.png";
import milluuCarefree from '../../resources/img/milluu-carefree.svg';
import milluuRiskFree from '../../resources/img/milluu-riskfree.svg';
import iconInfo from '../../resources/img/icon-info.svg';
import iconCheck from '../../resources/img/icon-check.svg';
import iconLine from '../../resources/img/icon-line.svg';


import '../../resources/styles/secondary-lp.scss';
import './Owners.scss';
import axios from 'axios';
import { AppModelService } from "../../AppModel.js";
import ContactUsComponent from '../../components/contact-us/ContactUsComponent';


const OwnersComponent = (props) => {

    const { t } = useTranslation();


    function log() {

        let link = t(`bannerOwners.button.link`);
        let finalLink = AppModelService.currentSettings().onboardingOwnerBaseUrl + link;

        if (Cookies.get('cookiebar') === 'CookieAllowed') {

            // const urlSearchParams = new URLSearchParams(window.location.search);
            // const params = Object.fromEntries(urlSearchParams.entries());
            let utmString = localStorage.getItem('utm');
            let utm = null;
            if (utmString) {
                try {
                    utm = JSON.parse(utmString);
                }
                catch (error) {
                    console.log('Error on parsing utm string ' + utmString + ': ' + error);
                }
            }

            console.log('Send lead utm: ' + utm);

            const ga = (window.ga && window.ga.getAll().length > 0) ? window.ga.getAll()[0].get('clientId') : 'adblock';
            const hj = (window.hj && window.hj.globals) ? window.hj.globals.key : 'adblock';

            // data to be sent to the POST request
            let _data = null;

            if (utm) {
                _data = {
                    'url': window.location.href,
                    'source': utm.source,
                    'medium': utm.medium,
                    'campaign': utm.campaign,
                    'content': utm.content,
                    'term': utm.term,
                    'finalurl': window.location.href,
                    'gid': ga,
                    'hjid': hj
                };
            }
            else {
                _data = {
                    'url': window.location.href,
                    'source': null,
                    'medium': null,
                    'campaign': null,
                    'content': null,
                    'term': null,
                    'finalurl': window.location.href,
                    'gid': ga,
                    'hjid': hj
                };
            }

            if (localStorage.getItem('ld')) {
                _data.ld = localStorage.getItem('ld');
            }
            const apiEndPoint = AppModelService.currentSettings().backendUri;
            axios.post(`${apiEndPoint}/add-lead.json`, _data)
                .then((response) => {
                    localStorage.setItem('ld', response.data);
                    window.location.href = finalLink;
                }, (error) => {
                    console.log(error);
                    //let xclock = t(`bannerOwners.button.link`);
                    window.location.href = finalLink;
                });

        } else {
            window.location.href = finalLink;
        }

    }

    return (
        <React.Fragment>
            {/* <Helmet>
            <title>
                {t('')}
            </title>
        </Helmet> */}

            <div className="owners-component secondary-lp">
                <Hero className="custom-hero" background={bgHero} gradient={gradientHero}>
                    <div className="wrapper-hero-description d-flex flex-column align-items-start">
                        {/* <img src={illustrationProprietar} alt=""/> */}
                        <div className="heroTextDesktop">
                            <h2 className="owner-h1"><Trans i18nKey={`bannerOwnersH1.title`} /></h2>
                            <h2 className="owner-h2"><Trans i18nKey={`bannerOwnersH1.title2`} /></h2>
                            <h2 className="owner-h3"><Trans i18nKey={`bannerOwnersH1.title3`} /></h2>
                            <MainButton onClick={log} title={t(`bannerOwners.button.title`)} shadow />
                        </div>
                    </div>
                </Hero>

                <div className="wrapper-section-under-hero">
                    <div className="heroTextMobile">
                        <h2 className="owner-h1"><Trans i18nKey={`bannerOwnersH1.title`} /></h2>
                        <h2 className="owner-h2"><Trans i18nKey={`bannerOwnersH1.title2`} /></h2>
                        <h2 className="owner-h3"><Trans i18nKey={`bannerOwnersH1.title3`} /></h2>
                        <MainButton onClick={log} title={t(`bannerOwners.button.title`)} />
                    </div>
                    <p className="section-title features-sub1"><strong>{t(`featuresOwners.subtitle`)} <br />
                        <span className="green-text">{t(`featuresOwners.coloredText`)}</span></strong></p>
                    <div className="features-sub2">
                        <p>{t(`featuresOwners.subtitle-2`)}
                            <br /><strong>{t(`featuresOwners.subtitle-2b`)}</strong>
                        </p>
                    </div>

                    <div className="section-features mtd">
                        <div className="container">
                            <div className="text-center text-md-start"></div>
                            <div className="justify-content-center row">
                                <div className="col-feature col-md-6">
                                    <div className="box-wrapper box-wrapper-nosh">

                                        <h3 className="section-title undefined-text"><strong>{t(`featuresOwners.features-pre.0.title`)}</strong></h3>
                                        <p>{t(`featuresOwners.features-pre.0.description`)}</p>

                                        <h3 className="section-title undefined-text mt-5"><strong>{t(`featuresOwners.features-pre.1.title`)}</strong></h3>
                                        <p>{t(`featuresOwners.features-pre.1.description`)}</p>
                                    </div>
                                </div>
                                <div className="col-feature col-feature-triangle col-md-6">
                                    <div className="box-wrapper box-wrapper-green">

                                        <h3 className="section-title undefined-text"><strong>{(t(`featuresOwners.features-pre.2.title`))}</strong></h3>
                                        <ul className="unstyled-list">
                                            {(t(`featuresOwners.featureslist`, { returnObjects: true })).map((feature, index) => {
                                                return (
                                                    <li key={index}><Trans i18nKey={`featuresOwners.featureslist.${index}`} /></li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <p className="section-title features-sub1 features-sub1-mobile"><strong>{t(`featuresOwners.subtitle-3`)} <br />
                        <span>{t(`featuresOwners.subtitle-3-1`)}</span></strong></p>
                    <p className="subpar">{t(`featuresOwners.subtitle-3-2-desktop`)}</p>

                    <Features features={t(`featuresOwners.features`, { returnObjects: true })}>
                        {/* <h2 className="section-title section-features-title border-color-orange">{t(`featuresOwners.title`)}</h2> */}
                    </Features>

                </div>

                <StepsContainer steps={t(`stepsOwners.steps`, { returnObjects: true })} title={<Trans i18nKey={`stepsOwners.title`} />} color="yellow" />

                <div className="section-costs" id="services">
                    <Container>
                        <h2 className="section-title text-center" style={{marginBottom: "16px"}}><Trans i18nKey={`servicesOwners.title`} /></h2>

                        <div className={`table-services ${props.tableActiveColumn}`}>
                            <div className="invisible-row">
                                <div className="col-row col-invisible-2" onClick={() => props.handleSetTableActiveColumn('active-2')} />
                                <div className="col-row col-invisible-3" onClick={() => props.handleSetTableActiveColumn('active-3')} />
                            </div>
                            <div className="row-head">
                                <div className="col-row">
                                </div>
                                <div className="col-row">
                                    <img src={milluuCarefree} alt="" />
                                    <h2 className="plan-title section-title orange-text">
                                        <strong><Trans i18nKey={`servicesOwners.categories.0.title`} /></strong></h2>
                                </div>
                                <div className="col-row">
                                    <img src={milluuRiskFree} alt="" />
                                    <h2 className="plan-title section-title violet-text">
                                        <strong><Trans i18nKey={`servicesOwners.categories.1.title`} /></strong></h2>
                                </div>
                            </div>
                            <div className="row-table d-flex d-md-none">
                                <div className="col-row d-none" />
                                <div className="col-row" />
                                <div className="col-row" />
                            </div>
                            {(t(`servicesOwners.options`, { returnObjects: true })).map((option, index) => {
                                return (
                                    <div key={index} className="row-table">
                                        <Modal show={props.showModal[index].modalInfo.open} onHide={() => props.handleCloseModal(index)}
                                            className="custom-modal step-modal" centered scrollable>
                                            <Modal.Header closeButton className="header-modal">
                                                <h2 className="section-title small-header"><strong>{option.title} </strong></h2>
                                            </Modal.Header>
                                            {/* <p><Trans i18nKey={option.modalInfo.description} /></p> */}
                                            <p dangerouslySetInnerHTML={{ __html: option.modalInfo.description }} />

                                        </Modal>

                                        <div className="col-row">
                                            <p className="option-title">
                                                {option.title}<span className='text-nowrap'>&#65279;<button className="unstyled-button info-btn"
                                                    onClick={() => props.handleShowModal(index)}><img src={iconInfo} alt="" />
                                                </button></span></p>
                                        </div>
                                        <div className="col-row">
                                            <img src={option.plan1 ? iconCheck : iconLine} alt="" />
                                        </div>
                                        <div className="col-row">
                                            <img src={option.plan2 ? iconCheck : iconLine} alt="" />
                                        </div>
                                    </div>
                                )
                            })}


                            <div className="row-footer">
                                <div className="col-row" />
                                {(t(`servicesOwners.categories`, { returnObjects: true })).map((col, catIndex) => {
                                    return (
                                        <div key={catIndex} className="col-row" onClick={() => props.handleSetTableActiveColumn(`active-${catIndex + 2}`)}>
                                            {col.fees.map((category, index) => {
                                                return (
                                                    <div key={index}>
                                                        <Modal show={props.showModalFee[catIndex].fees[index].modalInfo.open} onHide={() => props.handleCloseModalFee(catIndex, index)}
                                                            className="custom-modal step-modal" centered scrollable>
                                                            <Modal.Header closeButton className="header-modal">
                                                                <h2 className="section-title small-header"><strong><Trans i18nKey={category.title} /> </strong>{category.description}</h2>
                                                            </Modal.Header>
                                                            <p><Trans i18nKey={category.modalInfo.description} /></p>
                                                        </Modal>
                                                        <p style={{display: "block"}}>
                                                            <strong><Trans i18nKey={category.title} /></strong><span className='text-nowrap w-auto'>&#65279;
                                                            <button className="unstyled-button info-btn"
                                                                      onClick={() => props.handleShowModalFee(catIndex, index)}><img src={iconInfo} alt="" />
                                                            </button></span>
                                                            <br />
                                                            <span>{category.description}</span>
                                                        </p>
                                                    </div>
                                                )
                                            })}
                                            <MainButton href={col.button.link} title={col.button.title} />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </Container>
                </div>


                <div className="section-costs" id="cta2">
                    <h2 className="section-title text-center"><Trans i18nKey={`servicesOwners.title2`} /></h2>
                    <Container>
                        <div className="text-center text-md-start"></div>
                        <div className="justify-content-center row">
                            <div className="col-feature col-md-6">
                                <div className="box-wrapper box-wrapper-nosh">
                                    <div className="features-sub2">
                                        <p>{t(`featuresOwners.subtitle-4`)}
                                            <br /><strong>{t(`featuresOwners.subtitle-4b`)}</strong><br />

                                        </p>

                                    </div>
                                    <div className="mt-2 text-center">
                                        <MainButton onClick={log} title={t(`bannerOwners.button.title`)} />
                                    </div>
                                </div>

                            </div>
                            <div className="col-feature col-md-6">
                                <div className="box-wrapper box-wrapper-nosh">
                                    <div className="features-sub2">
                                        <img className="mlimage" src={illustrationQuestion} />

                                    </div>
                                </div>
                            </div>


                        </div>

                    </Container>
                </div>


                {(AppModelService.getCountry() === 'ro') &&
                    <SliderTestimonials testimonials={t(`reviewsOwners.reviews`, { returnObjects: true })}>
                        <Trans i18nKey={`reviewsOwners.title`} />
                    </SliderTestimonials>
                }

                <WhatIsMilluu />

                <div className='float-container'>
                    <ContactUsComponent/>
                </div>



            </div>
        </React.Fragment>

    );
};

export default OwnersComponent;